var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',_vm._l((_setup.searchFilterChips),function(chip){return _c(_setup.SearchFilterChip,{key:chip.key,attrs:{"label":chip.label,"value":chip.value},on:{"cleared":function($event){return _setup.updateLastSearch({ field: chip.key, value: chip.clearValue })}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }